import { clampTo, hasImageInput, needsTranslation } from '../tools';
import type { GeneralModelConfig } from './types';

export const generalModelConfigs: Record<string, GeneralModelConfig> = {
    'davinci': {
        apiPath: '',
        pollApiPath: '',
        synchronous: true,
        enableTranslation: false,
        statusMapping: {
            taskIdPath: '',
            statePath: '',
            success: [],
            failed: [],
            processing: [],
            imageUrlPath: 'lutImage',
            errorPath: '',
        },
        buildInput: (params) => {
            // 获取参数
            const { prompt, image_urls, size, aspectRatio, seed, image_size, image_resolution, providerOptions } = params;
            // 工具参数
            const po = (providerOptions ?? {}) as any;
            // 图像参数
            let image = undefined;
            if (!po.source_image_url) {
                const hasImage = hasImageInput(image_urls);
                if (!hasImage) {
                    throw new Error('Missing Image Input');
                } else {
                    image = image_urls[0];
                }
            } else {
                image = po.source_image_url;
            }
            // 图生图
            // 返回 Body 数据
            return {
                lutId: po.lut ? `l_lut:${po.lut}` : "l_lut:Arabica_12_e7cabb.CUBE",
                imageUrl: image,
            };
        },
    },
};